import { createContext, useState, useContext } from "react";
import apiClient from "../api/apiClients";

// Create a context for API management
const ApiContext = createContext();

// API Provider to manage the current API type and client
export const ApiProvider = ({ children, initialApiType }) => {
  const [apiType, setApiType] = useState(initialApiType || "databricks"); // Default to Databricks if none provided

  // Context value containing apiType, setApiType, and apiClient
  const contextValue = {
    apiType,
    setApiType,
    apiClient,
  };

  return (
    <ApiContext.Provider value={contextValue}>{children}</ApiContext.Provider>
  );
};

// Custom hook to use the API context
// eslint-disable-next-line react-refresh/only-export-components -- intentional hook export beside provider
export const useApi = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error("useApi must be used within an ApiProvider");
  }
  return context;
};
